function PropertyLoadingState() {
  return (
    <div className="min-h-screen text-[#183228]">
      <main className="mx-auto w-[min(900px,calc(100%-40px))] py-12">
        <section
          aria-live="polite"
          className="rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] p-8 shadow-[0_22px_60px_rgba(24,50,40,0.08)]"
          role="status"
        >
          <p className="mb-2 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Henter detaljside</p>
          <h1 className="font-serif text-3xl font-semibold text-[#163127]">Laster eiendom...</h1>
          <p className="mt-3 text-[1.05rem] leading-[1.7] text-[#355046]">Vi henter oppdatert informasjon om bolig, bilder og kart.</p>
        </section>
      </main>
    </div>
  );
}

export default PropertyLoadingState;